import type { ClinicianTO } from './Clinician';
import type { EpisodeTO } from './Episode';

//TODO:  to be linting all fields as camelCase
export interface ClinicTO {
  id: number;
  clinic: string;
  clinic_id: number;
  features?: object;
  roles?: object;
  tenancy_id: number;
  healthProfessionals?: string[];
  organisation_unit?: string;
  tags?: string[];
  client_no?: string;
  primaryTeams?: string[];
  caremapprClinicians?: ClinicianTO[];
  episodes?: EpisodeTO[];
  clinic_details?: Record<string, any>[];
  episode_opened_date?: string | null;
  episode_closed?: boolean;
  episode_closed_date?: string | null;
  episode_no?: string | null;
}

export interface CreatePatientClinic {
  clinicId: number;
  primaryTeams?: string[];
  healthProfessionals?: string[];
  episodeClosed?: boolean;
  episodeClosedDate?: string | null;
  episodeNo?: string | null;
  details?: Record<string, any>;
}

export const transformClinicTOToCreatePatientClinic = (
  clinics: ClinicTO[],
): CreatePatientClinic[] => {
  return clinics.map((clinic) => ({
    clinicId: clinic.clinic_id,
    primaryTeams: clinic.primaryTeams,
    healthProfessionals: Array.isArray(clinic.healthProfessionals)
      ? clinic.healthProfessionals
      : ((clinic.healthProfessionals?.[clinic.id] || []) as string[]),
    details: {
      organisationUnit: clinic.organisation_unit,
      clientNo: clinic.client_no,
      tags: clinic.tags,
      features: clinic.features,
      roles: clinic.roles,
    },
  }));
};
